import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import createSagaMiddleWare from 'redux-saga';
import { reducer as toastrReducer } from 'react-redux-toastr';

import { authReducer } from 'src/features/auth';
import rootSaga from './rootSaga';

import navigationReducer from '../features/layout/Navigation/store';
import individualLogReducer from '../features/hosLogs/store';
import loadingReducer from '../features/loading/loadingStore';
import profileReducer from 'src/features/profile/store/profileStore';
import movementReducer from 'src/features/movements/store/movementStore';
import { exceptionsListReducer } from 'src/features/hosLogs/exceptionsList/store/';

/* eslint-disable no-underscore-dangle */
/* eslint-disable no-undef */
const composeEnhancers: <R>(a: R) => R =
  (process.env.NODE_ENV === 'development' ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : null) ||
  compose;

const sagaMiddleWare = createSagaMiddleWare();

const rootReducer = combineReducers({
  auth: authReducer,
  navigation: navigationReducer,
  hosLog: individualLogReducer,
  loading: loadingReducer,
  toastr: toastrReducer,
  profile: profileReducer,
  exceptionsList: exceptionsListReducer,
  movements: movementReducer,
});

export const store = createStore(rootReducer, composeEnhancers(applyMiddleware(sagaMiddleWare)));

export type RootState = ReturnType<typeof rootReducer>;

sagaMiddleWare.run(rootSaga);
